<template>
  <div class="supply-demand">
    <!-- 顶部导航栏 -->
    <AppHeader />

    <!-- Banner区域 -->
    <div class="banner">
      <div class="banner-background">
        <div class="city-skyline">
          <img src="@/images/index2.png" alt="港口背景" class="skyline-image" />
        </div>
      </div>
      <div class="banner-content">
        <h1 class="banner-title">供需对接</h1>
        <p class="banner-subtitle">企业供需信息发布与对接平台</p>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 左侧导航菜单 -->
      <div class="sidebar">
        <nav class="sidebar-nav">
          <div 
            v-for="navItem in sidebarNavItems" 
            :key="navItem.key"
            :class="['nav-item', { 'active': activeNavItem === navItem.key }]"
            @click="setActiveNavItem(navItem.key)"
          >
            {{ navItem.label }}
          </div>
        </nav>
      </div>

      <!-- 右侧内容区域 -->
      <div class="content-area">
        <!-- 顶部按钮区域 -->
        <div class="top-actions">
          <div class="action-buttons">
          <button class="action-btn supply-btn" @click="showSupplyModal = true">
            提交供应信息
          </button>
          <button class="action-btn demand-btn" @click="showDemandModal = true">
            提交需求信息
          </button>
        </div>
        </div>

        <!-- 供需信息展示区域 -->
        <div class="supply-demand-display" v-loading="loading">
          <div v-if="currentDisplayList.length === 0 && !loading" class="empty-state">
            <i class="el-icon-document"></i>
            <p>暂无相关信息</p>
          </div>
          
          <div v-else class="supply-demand-grid">
            <div 
              v-for="item in currentDisplayList" 
              :key="item.id"
              class="supply-demand-item"
            >
              <div class="item-image">
                <img :src="item.supplyImage" :alt="item.title" />
              </div>
              <div class="item-content">
                <div class="item-header">
                  <span class="company-name">{{ item.name }}</span>
                </div>
                <div class="item-description">
                  <span class="description-text">{{ item.content }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 分页导航 -->
        <div class="pagination-nav">
          <button 
            class="nav-arrow prev" 
            @click="prevPage" 
            :disabled="currentPage === 1"
          >
            ←
          </button>
          
          <div class="page-numbers">
            <span 
              v-for="page in visiblePages" 
              :key="page"
              :class="['page-number', { 'active': page === currentPage }]"
              @click="goToPage(page)"
            >
              {{ page < 10 ? '0' + page : page }}
            </span>
          </div>
          
          <button 
            class="nav-arrow next" 
            @click="nextPage" 
            :disabled="currentPage === totalPages"
          >
            →
          </button>
        </div>
      </div>
    </div>
    
    <!-- 底部区域 -->
    <AppFooter />
    
    <!-- 供应信息模态框 -->
    <div v-if="showSupplyModal" class="modal-overlay" @click.self="closeSupplyModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>提交供应信息</h3>
          <button class="close-btn" @click="closeSupplyModal">×</button>
        </div>
        <el-form 
          ref="supplyForm"
          :model="supplyFormData" 
          :rules="supplyFormRules"
          class="modal-form"
          label-width="100px"
        >
          <el-form-item label="企业名称" prop="companyName">
            <el-input v-model="supplyFormData.companyName" placeholder="请输入企业名称"></el-input>
          </el-form-item>
          
          <el-form-item label="供应信息" prop="supplyInfo">
            <el-input 
              v-model="supplyFormData.supplyInfo" 
              type="textarea" 
              :rows="4"
              placeholder="请输入供应信息描述（最多240字符）"
              show-word-limit
              maxlength="240"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="企业联系人" prop="contactPerson">
            <el-input v-model="supplyFormData.contactPerson" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
          
          <el-form-item label="联系方式" prop="contactPhone">
            <el-input v-model="supplyFormData.contactPhone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          
          <div class="form-footer">
            <div class="service-phone">
              服务热线：400-123-4567
            </div>
            <div class="form-buttons">
              <el-button @click="closeSupplyModal">取消</el-button>
              <el-button type="primary" @click="submitSupplyForm">提交</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    
    <!-- 需求信息模态框 -->
    <div v-if="showDemandModal" class="modal-overlay" @click.self="closeDemandModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>提交需求信息</h3>
          <button class="close-btn" @click="closeDemandModal">×</button>
        </div>
        <el-form 
          ref="demandForm"
          :model="demandFormData" 
          :rules="demandFormRules"
          class="modal-form"
          label-width="100px"
        >
          <el-form-item label="企业名称" prop="companyName">
            <el-input v-model="demandFormData.companyName" placeholder="请输入企业名称"></el-input>
          </el-form-item>
          
          <el-form-item label="需求信息" prop="demandInfo">
            <el-input 
              v-model="demandFormData.demandInfo" 
              type="textarea" 
              :rows="4"
              placeholder="请输入需求信息描述（最多240字符）"
              show-word-limit
              maxlength="240"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="企业联系人" prop="contactPerson">
            <el-input v-model="demandFormData.contactPerson" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
          
          <el-form-item label="联系方式" prop="contactPhone">
            <el-input v-model="demandFormData.contactPhone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          
          <div class="form-footer">
            <div class="service-phone">
              服务热线：400-123-4567
            </div>
            <div class="form-buttons">
              <el-button @click="closeDemandModal">取消</el-button>
              <el-button type="primary" @click="submitDemandForm">提交</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>

  </div>
</template>

<script>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
import { api } from '@/utils/api'

export default {
  name: 'SupplyDemand',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      activeNavItem: 'market-demand',
      currentPage: 1,
      pageSize: 4,
      loading: false,
      showSupplyModal: false,
      showDemandModal: false,
      supplyFormData: {
        companyName: '',
        supplyInfo: '',
        contactPerson: '',
        contactPhone: ''
      },
      demandFormData: {
        companyName: '',
        demandInfo: '',
        contactPerson: '',
        contactPhone: ''
      },
      supplyFormRules: {
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        supplyInfo: [
          { required: true, message: '请输入供应信息', trigger: 'blur' },
          { max: 240, message: '供应信息不能超过240个字符', trigger: 'blur' }
        ],
        contactPerson: [
          { required: true, message: '请输入企业联系人', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      },
      demandFormRules: {
        companyName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        demandInfo: [
          { required: true, message: '请输入需求信息', trigger: 'blur' },
          { max: 240, message: '需求信息不能超过240个字符', trigger: 'blur' }
        ],
        contactPerson: [
          { required: true, message: '请输入企业联系人', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      },
      sidebarNavItems: [
        { key: 'market-demand', label: '市场需求' },
        { key: 'market-supply', label: '市场供应' },
        { key: 'trade-matching', label: '贸易撮合' }
      ],
      supplyDemandData: {
        'market-demand': [
           {
             id: 1,
             image: 'data:image/svg+xml;charset=utf-8,<svg width="200" height="150" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="150" fill="%23FFB366"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="16">起重机</text></svg>',
             companyName: '陕西陕汽汽车贸易营销有限公司',
             description: '徐工 XCT110 汽车起重机(二手)'
           },
           {
             id: 2,
             image: 'data:image/svg+xml;charset=utf-8,<svg width="200" height="150" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="150" fill="%23FF8C32"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="16">沙棘油</text></svg>',
             companyName: '陕西陕汽汽车贸易营销有限公司',
             description: '徐工 XCT110 汽车起重机(二手)'
           },
           {
             id: 3,
             image: 'data:image/svg+xml;charset=utf-8,<svg width="200" height="150" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="150" fill="%236FAADB"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="16">冰淇淋</text></svg>',
             companyName: '陕西陕汽汽车贸易营销有限公司',
             description: '徐工 XCT110 汽车起重机(二手)'
           },
           {
             id: 4,
             image: 'data:image/svg+xml;charset=utf-8,<svg width="200" height="150" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="150" fill="%2387CEEB"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="16">港口</text></svg>',
             companyName: '陕西陕汽汽车贸易营销有限公司',
             description: '徐工 XCT110 汽车起重机(二手)'
           },
           {
             id: 5,
             image: 'data:image/svg+xml;charset=utf-8,<svg width="200" height="150" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="150" fill="%2398D8C8"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="16">机械</text></svg>',
             companyName: '陕西陕汽汽车贸易营销有限公司',
             description: '徐工 XCT110 汽车起重机(二手)'
           },
           {
             id: 6,
             image: 'data:image/svg+xml;charset=utf-8,<svg width="200" height="150" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="150" fill="%23F7DC6F"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="16">设备</text></svg>',
             companyName: '陕西陕汽汽车贸易营销有限公司',
             description: '徐工 XCT110 汽车起重机(二手)'
           }
         ],
        'supply-demand': [
           {
             id: 7,
             image: 'data:image/svg+xml;charset=utf-8,<svg width="200" height="150" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="150" fill="%23BB8FCE"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="16">供需1</text></svg>',
             companyName: '供需对接企业A',
             description: '供需对接产品描述'
           },
           {
             id: 8,
             image: 'data:image/svg+xml;charset=utf-8,<svg width="200" height="150" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="150" fill="%2385C1E9"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="16">供需2</text></svg>',
             companyName: '供需对接企业B',
             description: '供需对接产品描述'
           }
         ],
         'market-supply': [
           {
             id: 9,
             image: 'data:image/svg+xml;charset=utf-8,<svg width="200" height="150" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="150" fill="%23F8C471"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="16">市场1</text></svg>',
             companyName: '市场供应企业A',
             description: '市场供应产品描述'
           },
           {
             id: 10,
             image: 'data:image/svg+xml;charset=utf-8,<svg width="200" height="150" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="150" fill="%2382E0AA"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="16">市场2</text></svg>',
             companyName: '市场供应企业B',
             description: '市场供应产品描述'
           }
         ],
         'trade-matching': [
           {
             id: 11,
             image: 'data:image/svg+xml;charset=utf-8,<svg width="200" height="150" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="150" fill="%23F1948A"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="16">贸易1</text></svg>',
             companyName: '贸易撮合企业A',
             description: '贸易撮合产品描述'
           },
           {
             id: 12,
             image: 'data:image/svg+xml;charset=utf-8,<svg width="200" height="150" xmlns="http://www.w3.org/2000/svg"><rect width="200" height="150" fill="%2385C1E9"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="16">贸易2</text></svg>',
             companyName: '贸易撮合企业B',
             description: '贸易撮合产品描述'
           }
         ]
      }
    }
  },
  
  computed: {
    currentDisplayList() {
      const data = this.supplyDemandData[this.activeNavItem] || []
      // 确保data是数组
      const dataArray = Array.isArray(data) ? data : []
      const startIndex = (this.currentPage - 1) * this.pageSize
      const endIndex = startIndex + this.pageSize
      return dataArray.slice(startIndex, endIndex)
    },
    
    totalPages() {
      const data = this.supplyDemandData[this.activeNavItem] || []
      // 确保data是数组
      const dataArray = Array.isArray(data) ? data : []
      return Math.ceil(dataArray.length / this.pageSize)
    },
    
    visiblePages() {
       const total = this.totalPages
       const pages = []
       
       for (let i = 1; i <= total; i++) {
         pages.push(i)
       }
       
       return pages
     }
  },
  
  mounted() {
    // 页面初始化时加载默认菜单的数据
    this.loadSupplyDemandData()
  },
  
  methods: {
    setActiveNavItem(navItem) {
      // 只有当菜单真正发生变化时才调用API
      if (this.activeNavItem !== navItem) {
        this.activeNavItem = navItem
        this.currentPage = 1
        this.loadSupplyDemandData()
      }
    },
    
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    },
    
    goToPage(page) {
      this.currentPage = page
    },
    
    async loadSupplyDemandData() {
      this.loading = true
      try {
        // 根据当前选中的菜单确定type参数
        let type = 0
        if (this.activeNavItem === 'market-demand') {
          type = 0
        } else if (this.activeNavItem === 'market-supply') {
          type = 1
        } else if (this.activeNavItem === 'trade-matching') {
          type = 2
        }
        
        // 调用API接口
        const response = await api.getSupplyDemandList(type)
        
        if (response && response.code === 200) {
          // 更新对应菜单的数据
          this.$set(this.supplyDemandData, this.activeNavItem, response.result.records || [])
        } else {
          this.$message.error('数据加载失败')
        }
      } catch (error) {
        console.error('API调用失败:', error)
        this.$message.error('网络请求失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    
    submitSupplyForm() {
      this.$refs.supplyForm.validate((valid) => {
        if (valid) {
          // 提交供应信息
          console.log('提交供应信息:', this.supplyFormData)
          this.showSupplyModal = false
          this.resetSupplyForm()
          this.$message.success('供应信息提交成功')
        }
      })
    },
    
    submitDemandForm() {
      this.$refs.demandForm.validate((valid) => {
        if (valid) {
          // 提交需求信息
          console.log('提交需求信息:', this.demandFormData)
          this.showDemandModal = false
          this.resetDemandForm()
          this.$message.success('需求信息提交成功')
        }
      })
    },
    
    resetSupplyForm() {
      this.supplyFormData = {
        companyName: '',
        supplyInfo: '',
        contactPerson: '',
        contactPhone: ''
      }
      if (this.$refs.supplyForm) {
        this.$refs.supplyForm.resetFields()
      }
    },
    
    resetDemandForm() {
      this.demandFormData = {
        companyName: '',
        demandInfo: '',
        contactPerson: '',
        contactPhone: ''
      }
      if (this.$refs.demandForm) {
        this.$refs.demandForm.resetFields()
      }
    },
    
    closeSupplyModal() {
      this.showSupplyModal = false
      this.resetSupplyForm()
    },
    
    closeDemandModal() {
      this.showDemandModal = false
      this.resetDemandForm()
    }
  }
}
</script>

<style scoped>
/* 基础样式 */
.supply-demand {
  min-height: 100vh;
  background: #f5f7fa;
}

/* Banner样式 */
.banner {
  position: relative;
  height: 400px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.city-skyline {
  width: 100%;
  height: 100%;
  position: relative;
}

.skyline-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-content {
  position: relative;
  z-index: 2;
  text-align: center;
  color: white;
}

.banner-title {
  font-size: 48px;
  font-weight: bold;
  margin: 0 0 10px 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.banner-subtitle {
  font-size: 20px;
  margin: 0;
  opacity: 0.9;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

/* 主要内容区域 */
.main-content {
  max-width: 1200px;
  margin: 30px auto 0;
  padding: 0 20px 50px;
  position: relative;
  z-index: 3;
  display: flex;
  gap: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  min-height: 600px;
}

/* 左侧导航菜单 */
.sidebar {
  width: 200px;
  background: #f8f9fa;
  border-radius: 12px 0 0 12px;
  padding: 0;
}

.sidebar-nav {
  padding: 0;
}

.nav-item {
  padding: 15px 20px;
  cursor: pointer;
  border-bottom: 1px solid #e9ecef;
  transition: all 0.3s ease;
  font-weight: 500;
  color: #495057;
}

.nav-item:hover {
  background: #e9ecef;
  color: #007bff;
}

.nav-item.active {
  background: #007bff;
  color: white;
  position: relative;
}

.nav-item.active::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid #007bff;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
}

/* 右侧内容区域 */
.content-area {
  flex: 1;
  padding: 30px;
  display: flex;
  flex-direction: column;
}

/* 顶部按钮区域 */
.top-actions {
  margin-bottom: 30px;
}

.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
}

.action-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  font-size: 14px;
}

.supply-btn {
  background: #e9ecef;
  color: #495057;
  border: 1px solid #ced4da;
}

.supply-btn:hover {
  background: #dee2e6;
}

.demand-btn {
  background: #007bff;
  color: white;
}

.demand-btn:hover {
  background: #0056b3;
}

/* 供需信息展示区域 */
.supply-demand-display {
  flex: 1;
  margin-bottom: 30px;
}

.supply-demand-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.supply-demand-item {
  display: flex;
  flex-direction: column;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.supply-demand-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.item-image {
  width: 100%;
  height: 150px;
  flex-shrink: 0;
}

.item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.item-content {
  padding: 15px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.item-header {
  margin-bottom: 10px;
}

.company-label,
.description-label {
  color: #6c757d;
  font-size: 14px;
  font-weight: 500;
}

.company-name,
.description-text {
  color: #212529;
  font-size: 14px;
  margin-left: 5px;
}

.item-description {
  line-height: 1.5;
}

/* 分页导航 */
.pagination-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: auto;
}

.nav-arrow {
  width: 40px;
  height: 40px;
  border: 1px solid #dee2e6;
  background: white;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  font-size: 16px;
  color: #6c757d;
}

.nav-arrow:hover:not(:disabled) {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

.nav-arrow:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-numbers {
  display: flex;
  gap: 5px;
}

.page-number {
  width: 40px;
  height: 40px;
  border: 1px solid #dee2e6;
  background: white;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
}

.page-number:hover {
  background: #e9ecef;
}

.page-number.active {
  background: #007bff;
  color: white;
  border-color: #007bff;
}



.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #8c9eff;
}

.empty-state i {
  font-size: 4rem;
  margin-bottom: 20px;
  display: block;
}

.empty-state p {
  font-size: 1.1rem;
  margin: 0;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
}

.detail-modal {
  max-width: 700px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #333;
}

.modal-form {
  padding: 20px 30px;
}

.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.service-phone {
  font-size: 12px;
  color: #666;
}

.form-buttons {
  display: flex;
  gap: 10px;
}

/* 详情模态框 */
.detail-content {
  padding: 20px 30px;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.detail-description {
  margin-bottom: 25px;
}

.detail-description h4 {
  margin: 0 0 10px 0;
  font-size: 16px;
  color: #333;
}

.detail-description p {
  margin: 0;
  line-height: 1.6;
  color: #666;
}

.detail-info {
  margin-bottom: 25px;
}

.info-row {
  display: flex;
  margin-bottom: 10px;
}

.info-row label {
  width: 80px;
  color: #888;
  font-size: 14px;
}

.info-row span {
  color: #333;
  font-size: 14px;
}

.detail-tags h4 {
  margin: 0 0 10px 0;
  font-size: 16px;
  color: #333;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tags-container .tag {
  padding: 5px 12px;
  background: #f0f2f5;
  color: #666;
  border-radius: 15px;
  font-size: 12px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .banner-title {
    font-size: 32px;
  }
  
  .banner-subtitle {
    font-size: 16px;
  }
  
  .main-content {
    margin-top: -30px;
    padding: 0 15px 30px;
    flex-direction: column;
  }
  
  .sidebar {
    width: 100%;
    border-radius: 12px 12px 0 0;
  }
  
  .sidebar-nav {
    display: flex;
    overflow-x: auto;
  }
  
  .nav-item {
    white-space: nowrap;
    border-bottom: none;
    border-right: 1px solid #e9ecef;
  }
  
  .content-area {
    padding: 20px;
  }
  
  .supply-demand-grid {
    grid-template-columns: 1fr;
  }
  
  .action-buttons {
    justify-content: center;
  }
  
  .pagination-nav {
    flex-wrap: wrap;
    gap: 5px;
  }
  
  .page-numbers {
    order: -1;
    width: 100%;
    justify-content: center;
    margin-bottom: 10px;
  }
  
  .modal-content {
    width: 95%;
    margin: 20px;
  }
  
  .modal-header,
  .modal-form,
  .detail-content {
    padding: 15px 20px;
  }
  
  .form-footer {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
  
  .form-buttons {
    justify-content: center;
  }
  
  .form-buttons .el-button {
    width: 100%;
  }
}
</style>